var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"userPolicies"},[_c('h2',{staticClass:"userPolicies__title"},[_vm._v("Politicas de usuario")]),_c('div',{staticClass:"polices-list"},_vm._l((_vm.policesByUser),function(policy){return _c('UserPolicy',{key:policy._id,attrs:{"policy":policy,"user":_vm.user},on:{"change":_vm.onChange}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }